goog.provide('el8.appchart.dialog.ordermed.fulfillRx');

goog.require('el8.appchart.dialog.ordermed.selectPharmacy');
goog.require('el8.service.tz');
goog.require('el8.template.appchart.dialog.ordermed.fulfillRx');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.uiwidget.Form');

//
// This is the "Prescription Summary" dialog
//
el8.appchart.dialog.ordermed.fulfillRx = (function() {
    var rxForm = null,
        rx = null,

        // Added for interacting with the new React prescription form
        reactOptions = {},

        bulkRefillForm = null,
        selectedPharmacy = null,
        selectedServiceLocationId = null,
        controlledOnly = false,
        controlledMeds = false;

    var pharmacySelector = '.pharmacy-info';

    var that = new el8.uiwidget.NewDialog({
        title: 'Prescription Summary',
        autoHeight: true,
        width: 600,
        position: 'center'
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'eRxPrint', 'ePrescribe & Print Pt Copy', function() {
            that._doERx(true);
        }, true
    );
    buttonSet.addButton(
        'eRx', 'ePrescribe Only', function() {
            that._doERx(false);
        }
    );
    buttonSet.addButton(
        'print', 'Print Paper Rx', function() {
            that._doPrint('Print Paper Rx');
        }
    );
    buttonSet.addButton(
        'cancel', 'Cancel', function() {
            if (reactOptions.onCancel) {
              reactOptions.onCancel();
            } else {
              if (rxForm) { rxForm.enableDialog(); }
              if (bulkRefillForm) { bulkRefillForm.deleteQueue(); }
            }
            that.hide();
        }
    );
    that.setButtonSet(buttonSet);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        $(that.getContainer()).on('click', '.change-pharmacy',  function() {
            that._showSelectPharmacyDialog();
        });
        // listen for the click that opens up the settings page in a new tab
        $(that.getContainer()).on('click', '.erx-service-location-default',  function() {
            window.open(el8.service.urls.get('userSettings', ['appprefs']), '_blank');
        });
    };

    var super_show = that.show;
    that.show = function(_rxForm, _rx, _bulkRefillForm, _reactOptions) {
        rxForm = _rxForm || null;
        rx = _rx || null;
        bulkRefillForm = _bulkRefillForm || null;
        reactOptions = _reactOptions || {};

        var pharmacyDialogVisible = false;
        var usedControlledForm = rxForm && rxForm._printFormType === 'controlled';
        super_show.call(that);

        var set = that._createRxSet();
        that.setContent( el8.template.appchart.dialog.ordermed.fulfillRx.content({
            set : set
        }) );
        that._renderPharmacyInfo(); // pharm will start as empty and be filled below
        that._renderPracticeHeader(set);

        controlledOnly = (set.controlled.length && !set.prescriptions.length);
        controlledMeds = set.controlled.length;

        if (!el8Globals.FEATURES.MDToolboxEPCS) {
            // old logic to remove
            if (controlledOnly) {
                buttonSet.disableButton('eRxPrint');
                buttonSet.disableButton('eRx');
                $(pharmacySelector, that.getContainer()).hide();
            } else {
                var deniedRefillRequest = that._getDeniedRefillRequest();
                var pharmacyNcpdpid = null;

                if (el8.ptdata.ptPreferences.getPrefPharmacy1Key()) {
                    pharmacyNcpdpid = el8.ptdata.ptPreferences.getPrefPharmacy1Key();
                } else if (el8.ptdata.ptPreferences.getPrefPharmacy2Key()) {
                    pharmacyNcpdpid = el8.ptdata.ptPreferences.getPrefPharmacy2Key();
                } else {
                    pharmacyNcpdpid = el8.ptdata.ptPreferences.getLastPharmacyKey();
                }

                if (deniedRefillRequest) {
                    // If it's a denied refill request, display requested pharmacy
                    if (deniedRefillRequest.getPharmacyNcpdpid()) {
                        selectedPharmacy = el8.data.pharmacies.getByKey(
                            deniedRefillRequest.getPharmacyNcpdpid()
                        );
                    }
                    that._renderPharmacyInfo({
                        name: deniedRefillRequest.getPharmacyName(),
                        addressLine: deniedRefillRequest.getPharmacyAddressLine(),
                        cityStateZip: deniedRefillRequest.getPharmacyCityStateZip(),
                        phone: deniedRefillRequest.getPharmacyPhone(),
                        fax: deniedRefillRequest.getPharmacyFax()
                    });

                } else if (pharmacyNcpdpid) {
                    // Default to preferred pharmacy (or last used pharmacy), if available
                    selectedPharmacy = el8.data.pharmacies.getByKey(pharmacyNcpdpid);
                    that._renderPharmacyInfo();
                } else {
                    // If no pharmacy to display, immediately open up 'select pharmacy' dialog
                   pharmacyDialogVisible = true;
                   that._showSelectPharmacyDialog();
                }
            }
        } else {
            // Don't show eRx buttons and hide pharm if there are some controlled and user is not EPCS-enabled
            if ((set.controlled.length || usedControlledForm) && !el8.data.currUser.isEpcsEnabled()) {
                buttonSet.disableButton('eRxPrint');
                buttonSet.disableButton('eRx');
                $(pharmacySelector, that.getContainer()).hide();
            } else {
                var deniedRefillRequest = that._getDeniedRefillRequest();
                var pharmacyNcpdpid = null;

                if (el8.ptdata.ptPreferences.getPrefPharmacy1Key()) {
                    pharmacyNcpdpid = el8.ptdata.ptPreferences.getPrefPharmacy1Key();
                } else if (el8.ptdata.ptPreferences.getPrefPharmacy2Key()) {
                    pharmacyNcpdpid = el8.ptdata.ptPreferences.getPrefPharmacy2Key();
                } else {
                    pharmacyNcpdpid = el8.ptdata.ptPreferences.getLastPharmacyKey();
                }

                if (deniedRefillRequest) {
                    // If it's a denied refill request, display requested pharmacy
                    if (deniedRefillRequest.getPharmacyNcpdpid()) {
                        selectedPharmacy = el8.data.pharmacies.getByKey(
                            deniedRefillRequest.getPharmacyNcpdpid()
                        );
                    }
                    that._renderPharmacyInfo({
                        name: deniedRefillRequest.getPharmacyName(),
                        addressLine: deniedRefillRequest.getPharmacyAddressLine(),
                        cityStateZip: deniedRefillRequest.getPharmacyCityStateZip(),
                        phone: deniedRefillRequest.getPharmacyPhone(),
                        fax: deniedRefillRequest.getPharmacyFax()
                    });

                } else if (pharmacyNcpdpid) {
                    // Default to preferred pharmacy (or last used pharmacy), if available
                    selectedPharmacy = el8.data.pharmacies.getByKey(pharmacyNcpdpid);
                    that._renderPharmacyInfo();
                } else {
                    // If no pharmacy to display, immediately open up 'select pharmacy' dialog
                   pharmacyDialogVisible = true;
                   that._showSelectPharmacyDialog();
                }
            }
        }

        that.adjustPosition();
        if (!pharmacyDialogVisible) {
            buttonSet.focusButton('eRxPrint'); // Focus on eRx button unless there is a dialog above this
        }

        // If we're doing EPCS, update the button captions with "approve" (even in the mixed case)
        if (el8Globals.FEATURES.MDToolboxEPCS && el8.data.currUser.isEpcsEnabled() &&
            (controlledMeds || usedControlledForm)) {
            buttonSet.updateButtonCaption('eRxPrint', 'Approve, ePrescribe & Print Pt Copy');
            buttonSet.updateButtonCaption('eRx', 'Approve & ePrescribe Only');
        }
        else {
            buttonSet.updateButtonCaption('eRxPrint', 'ePrescribe & Print Pt Copy');
            buttonSet.updateButtonCaption('eRx', 'ePrescribe Only');
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        if (rxForm) { rxForm.enableDialog(); }

        selectedPharmacy = null;
        rxForm = null;
        rx = null;
        reactOptions = {};
        $(pharmacySelector, that.getContainer()).show();
        that._renderPharmacyInfo();

        buttonSet.enableButton('eRxPrint');
        buttonSet.enableButton('eRx');

        super_hide.call(that);
    };

    that._createRxSet = function() {
        // Get array of rxs that are queued to be printed
        var rxs = [], prescriptions = [], controlled = [];
        if (rxForm) {
            rxs = rxForm.getPrintQueue().map(function(a) { return a.item; });
        } else if (rx) {
            rxs = [rx];
        } else if (bulkRefillForm) {
            rxs = bulkRefillForm.getRxSet();
        }

        if (reactOptions.prescriptions) {
          prescriptions = reactOptions.prescriptions;
        } else {
          for (var i=0; i<rxs.length; i++) {
            var rxMap = rxs[i].asSoyMap();
            if (rxs[i].getMedication().isControlled()) {
              controlled.push(rxMap);
            } else {
              prescriptions.push(rxMap);
            }
          }
        }

        var rxPrescriberName;
        if (reactOptions.prescribingPhysicianId) {
          rxPrescriberName = el8.data.practiceUsers.getByStaffId(
            reactOptions.prescribingPhysicianId
          ).getFullName();
        } else if (reactOptions.prescribingPhysicianId === null) {
          // undefined means not specified at all, but null means a null value was
          // explicitly passed over from React, so there is no prescribing physician.
          rxPrescriberName = 'Unknown Prescriber';
        } else {
          rxPrescriberName = rxs[0].getPrescribingPhysicianName();
        }

        var documentDate;
        if (reactOptions.documentDate) {
          documentDate = reactOptions.documentDate;
        } else {
          documentDate = el8.service.tz.soyStr(rxs[0].getDocumentDate());
        }

        var deniedRefillRequest = that._getDeniedRefillRequest();
        deniedRefillRequest = deniedRefillRequest ? deniedRefillRequest.asSoyMap() : null;

        var denialReason;
        if (reactOptions.denialReason !== undefined) {
          denialReason = reactOptions.denialReason;
        } else {
          denialReason = rxs[0].getMetadata()['denial_note'];
        }

        var set = {
            rxPrescriberName: rxPrescriberName,
            signUserBehalfName: el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace().length ?
                el8.data.currUser.getFullName() : null,
            documentDate: documentDate,
            practice: el8.data.currPractice.asSoyMap(),
            patient: el8.ptdata.currPatient.asSoyMap(),
            prescriptions: prescriptions,
            controlled: controlled,
            deniedRefillRequest: deniedRefillRequest,
            denialReason: denialReason
        };

        return set;
    };

    that._getDeniedRefillRequest = function() {
        if (reactOptions.deniedRefillRequestId) {
          return el8.ptdata.rxRefillRequests.getById(reactOptions.deniedRefillRequestId);
        } else if (reactOptions.deniedRefillRequestId === null) {
          return null;
        }

        var rxs = [];
        if (rxForm) {
            rxs = rxForm.getPrintQueue().map(function(a) { return a.item; });
        } else if (rx) {
            rxs = [rx];
        } else if (bulkRefillForm) {
            rxs = bulkRefillForm.getRxSet();
        }
        var deniedRefillRequestId = rxs[0].getMetadata()['refill_request_id'];
        var deniedRefillRequest = null;
        if (deniedRefillRequestId) {
            deniedRefillRequest = el8.ptdata.rxRefillRequests.getById(deniedRefillRequestId);
        }
        return deniedRefillRequest;
    };

    that._renderPharmacyInfo = function(deniedPharmacyDetails) {
        var pharmacyDiv = $(pharmacySelector, that.getContainer());

        if (deniedPharmacyDetails) {
            pharmacyDiv.html(
                el8.template.appchart.dialog.ordermed.fulfillRx.pharmacy({
                    canChange: false,
                    pharmacy: deniedPharmacyDetails
                })
            );
        } else if (selectedPharmacy) {
            pharmacyDiv.html(
                el8.template.appchart.dialog.ordermed.fulfillRx.pharmacy({
                    canChange: true,
                    pharmacy: selectedPharmacy.asSoyMap()
                })
            );
        } else {
            pharmacyDiv.html(
                el8.template.appchart.dialog.ordermed.fulfillRx.noPharmacy()
            );
        }
    };

    that._renderServiceLocationDetail = function(serviceLocationId) {
        // render the detail of the service location (name, address, phone, fax) with a template
        var serviceLocation = el8.data.serviceLocations.getById(serviceLocationId);
        $('.erx-service-location-detail', that.getContainer()).html(el8.template.appchart.dialog.ordermed.fulfillRx.erxConfirmationPracticeHeaderServiceLocation({
            serviceLocation: serviceLocation.asSoyMap()
        }));
    };

    that._renderPracticeHeaderByServiceLocations = function(set) {
        // callback after the list of service locations are loaded.
        var practiceHeaderDiv = $('.practice-header-container', that.getContainer());
        if (el8.data.serviceLocations.all().length <= 1) {
            // if there are only 1 service location, just render the default practice header
            practiceHeaderDiv.html(el8.template.data.practices.header(set.practice));
        } else {
            // there are more than 1 service locations, render a selection to let the user pick which service location to use
            practiceHeaderDiv.html(el8.template.appchart.dialog.ordermed.fulfillRx.erxConfirmationPracticeHeader({
                serviceLocations: el8.data.serviceLocations.sortedAsSoyMaps()
            }));
            var form = new el8.uiwidget.Form({
                container: $('.service-location-form', that.getContainer()),
                fields: [{
                    name: 'eRxServiceLocation',
                    selector: ':input[name="eRxServiceLocation"]',
                    changeFn: function() {
                        // set the selected location
                        selectedServiceLocationId = form.getVal('eRxServiceLocation');
                        // render the detail on screen
                        that._renderServiceLocationDetail(selectedServiceLocationId);
                    }
                 }]
            });
            form.render();
            // make sure the <a> links still work
            form.unbindButtonEvents();

            // set up the default based on the user preference
            selectedServiceLocationId = el8.data.currUser.getDefaultErxServiceLocationId();
            form.setVal('eRxServiceLocation', selectedServiceLocationId, true);
            // render the detail of the location based on the current choice
            that._renderServiceLocationDetail(form.getVal('eRxServiceLocation'));
        }
        that.adjustPosition();
    };

    that._renderPracticeHeader = function(set) {
        // load the service locations to determine if we need to render a single header or a control
        el8.data.serviceLocations.softLoad(function() {
            that._renderPracticeHeaderByServiceLocations(set);
        }, true);
    };

    that._showSelectPharmacyDialog = function() {
        // Allow pharmacy selection if EPCS enabled
        if (!controlledOnly ||
            (el8Globals.FEATURES.MDToolboxEPCS && el8.data.currUser.isEpcsEnabled())) {
            var saveCb = function(newPharmacy) {
                selectedPharmacy = newPharmacy;
                that._renderPharmacyInfo();
                that.adjustPosition();
            };
            var printCb = function() { that._doPrint('Print Only'); };
            var hideCb = function() { buttonSet.focusButton('eRxPrint'); };

            el8.appchart.dialog.ordermed.selectPharmacy.show({
                saveCallbackFn: saveCb,
                printCallbackFn: printCb,
                hideCallbackFn: hideCb,
                controlledMeds: !!controlledMeds
            });
        }
    };

    that._doPrint = function(amplitudeSource) {
        if (rxForm) {
            rxForm.doPrint(amplitudeSource);
        } else if (rx) {
            el8.ptdata.medOrders.printSingle(rx);
        } else if (bulkRefillForm) {
            bulkRefillForm.doPrint();
        } else if (reactOptions.onPrint) {
            reactOptions.onPrint();
        }
        that.hide();
    };

    that._doERx = function(print) {
        if (!selectedPharmacy) {
            that._showSelectPharmacyDialog();
        } else {
            if (rxForm) {
                if (print) {
                    rxForm.doERxAndPrint(selectedPharmacy, selectedServiceLocationId);
                } else {
                    rxForm.doERx(selectedPharmacy, selectedServiceLocationId);
                }
            } else if (rx) {
                el8.ptdata.medOrders.eRxSingle(rx, selectedPharmacy, selectedServiceLocationId, null, true);
            } else if (bulkRefillForm) {
                if (print) {
                    bulkRefillForm.doERxAndPrint(selectedPharmacy, selectedServiceLocationId);
                } else {
                    bulkRefillForm.doERx(selectedPharmacy, selectedServiceLocationId);
                }
            } else if (print && reactOptions.onEPrescribeAndPrint) {
                reactOptions.onEPrescribeAndPrint(selectedPharmacy.getNcpdpid(), selectedServiceLocationId);
            } else if (!print && reactOptions.onEPrescribe) {
                reactOptions.onEPrescribe(selectedPharmacy.getNcpdpid(), selectedServiceLocationId);
            }
            that.hide();
        }
    };

    return that;

})();
